import { render, staticRenderFns } from "./ResortsView.vue?vue&type=template&id=353975a1&scoped=true&"
import script from "./ResortsView.vue?vue&type=script&lang=js&"
export * from "./ResortsView.vue?vue&type=script&lang=js&"
import style0 from "./ResortsView.vue?vue&type=style&index=0&id=353975a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353975a1",
  null
  
)

export default component.exports